import React, { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";

export const OficinaVirtualControllerContext = createContext();

export const ACTIONS = {
  SET_DATA_TABLE: "SET_DATA_TABLE",
};

const initialState = {
  dataTable: null,
};

const OficinaVirtualControllerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_DATA_TABLE: {
      return {
        ...state,
        dataTable: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

const OficinaVirtualControllerContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(
    OficinaVirtualControllerReducer,
    initialState
  );

  useEffect(() => {
    LiferayService.getOficinaVirtual(properties.base_url_api).then(
      (response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_DATA_TABLE,
        });
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OficinaVirtualControllerContext.Provider value={[state, dispatch]}>
      {children}
    </OficinaVirtualControllerContext.Provider>
  );
};

export default OficinaVirtualControllerContextProvider;
